const doc = [({"zh_tw":({"adminConstantCompanyAdminUserRoleType":({"admin":"管理員", "facilityAdmin":"設施管理員", "facilityOperator":"設施運營商"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;